import React from "react";
import { connect } from "react-redux";
import ReportSiniestro from "powerbi-report-component";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";
const config = {};


class DiasReposoGrafico extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  render() {
    const reporte = [];
    if (this.props.companyId) {
      config.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSection3b7b201bd013175e1e57&filter=Tabla_x0020_Ruts_x0020_Empresa/Rut eq '${this.props.companyId.replace('-','')}'`;

      config.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };

      const key = `diasReposo${new Date().getTime()}`;
      reporte.push(<ReportSiniestro
        key={key}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config.embedUrl}
        embedId={this.props.config.embedId}
        extraSettings={{
          filterPaneEnabled: config.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config.extraSettings.navContentPaneEnabled,

        }}
        permissions="All"
        style={{
          height: "50%",
          border: "0",
          padding: "0px",
          background: "#eee",
        }}
      />);
    }


    return (
      <React.Fragment>
        <div className='header-subTitle' style={{ marginBottom: 5, marginTop: 0 }}>Días de reposo asociados a trabajadores que han consultado en algún centro ACHS por cualquier motivo asociado a COVID-19.</div>
        {reporte}
        <div className='covid-footer'>
          <div className='header-subTitle'><b>Glosario</b></div>
          <ul className='itemlist'>
            <li className='itemlist'><div className='header-subTitle'><b>Covid Positivo: </b><span>días de reposo asociados a trabajadores a los que se tomó exámen PCR y el resultado es positivo para COVID-19</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Bajo Sospecha: </b><span>días de reposo asociados a trabajadores con síntomas sospechosos de COVID-19, que aún no tienen resultado de su exámen PCR o que por su califiación fueron derivados al sistema de salud común</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Contacto Estrecho: </b><span>días de reposo asociados a trabajadores que refieren haber tenido contacto con un enfermo o sospechoso de COVID-19, o que han sido reportados por la autoridad sanitaria y no presentan síntomas de la enfermedad</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Descartado: </b><span>días de reposo asociados a trabajadores a los que se tomó exámen PCR y el resultado es negativo para COVID-19 o que cumplieron el periodo de aislamiento sin desarrollar la enfermedad</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Reposo Activo: </b><span>días de reposo asociados a trabajadores que actualmente se encuentran con reposo laboral</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Dados de Alta: </b><span>días de reposo asociados a trabajadores que han tenido reposo laboral pero están dados de alta</span></div></li>
          </ul>
        </div>
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({
  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  //sucursalId: state.global.sucursalId,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DiasReposoGrafico);

